import pickBy from 'lodash/pickBy'

// Takes list of agreementProducts and a map of productId:quantity and creates
// lineItems for submiting/editing a draft order
export const createLineItems = (agreementProducts, productQuantities) => {
  const quantities = pickBy(productQuantities)
  const productIds = Object.keys(quantities)
  const lineItems = productIds.map(id => {
    const agreementProduct = agreementProducts.find(
      ap => ap.product.id === Number(id)
    )
    return {
      agreementProductId: agreementProduct.id,
      quantity: quantities[id],
    }
  })
  return lineItems
}

export const getFieldErrors = (
  lineItemErrors,
  lineItems,
  agreementProducts
) => {
  const fieldErrors = lineItemErrors.reduce(
    (fieldErrors, lineItemError, idx) => {
      if (Object.keys(lineItemError).length) {
        const lineItem = lineItems[idx]
        const ap = agreementProducts.find(
          ap => ap.id === lineItem.agreementProductId
        )
        let error = Object.values(lineItemError)[0]
        fieldErrors[ap.product.id] = error
      }
      return fieldErrors
    },
    {}
  )

  return fieldErrors
}

export const orderFormActionOptions = {
  errorNotification: error => {
    if (error.payload?.status === 400) {
      return 'Please check the form for errors'
    }
  },
}
